import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Search, Filter } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const campaigns = [{
  name: "Summer Run '26",
  artist: 'The Wildwoods',
  region: 'Midwest-NE',
  dates: 'Jun 10-25',
  status: 'Active',
  targets: 42,
  replies: 14,
  offers: 6,
  confirmed: 3,
  health: 'good'
}, {
  name: 'Fall Northeast',
  artist: 'Sarah Jarosz',
  region: 'Northeast',
  dates: 'Sep 5-20',
  status: 'Planning',
  targets: 28,
  replies: 0,
  offers: 0,
  confirmed: 0,
  health: 'neutral'
}, {
  name: 'Texas Spring',
  artist: 'Mark Erelli',
  region: 'Texas',
  dates: 'Mar 15-28',
  status: 'Completed',
  targets: 18,
  replies: 12,
  offers: 8,
  confirmed: 6,
  health: 'great'
}, {
  name: 'West Coast Fall',
  artist: 'The Wildwoods',
  region: 'West Coast',
  dates: 'Oct 1-18',
  status: 'Draft',
  targets: 0,
  replies: 0,
  offers: 0,
  confirmed: 0,
  health: 'neutral'
}, {
  name: 'Holiday Shows',
  artist: 'Various',
  region: 'Regional',
  dates: 'Dec 10-23',
  status: 'Planning',
  targets: 15,
  replies: 3,
  offers: 1,
  confirmed: 0,
  health: 'warning'
}];
export function CampaignsPage() {
  const navigate = useNavigate();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto" data-id="element-2557">
      {/* Header & Filters */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-2558">
        <div className="flex flex-wrap items-center gap-3" data-id="element-2559">
          <div className="relative" data-id="element-2560">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-2561" />
            <input type="text" placeholder="Search campaigns..." className="pl-9 pr-4 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary w-64" data-id="element-2562" />
          </div>
          <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-2563">
            <option data-id="element-2564">All Statuses</option>
            <option data-id="element-2565">Active</option>
            <option data-id="element-2566">Planning</option>
          </select>
          <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-2567">
            <option data-id="element-2568">All Artists</option>
            <option data-id="element-2569">The Wildwoods</option>
          </select>
          <button className="p-2 bg-surface border border-border rounded-lg text-textMuted hover:text-textMain transition-colors" data-id="element-2570">
            <Filter className="w-4 h-4" data-id="element-2571" />
          </button>
        </div>
        <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2 text-sm shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-2572">
          <Plus className="w-4 h-4" data-id="element-2573" />
          New Campaign
        </button>
      </div>

      {/* Table */}
      <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-2574">
        <div className="overflow-x-auto" data-id="element-2575">
          <table className="w-full text-sm text-left" data-id="element-2576">
            <thead className="bg-surface border-b border-border text-textMuted" data-id="element-2577">
              <tr data-id="element-2578">
                <th className="px-6 py-4 font-medium" data-id="element-2579">Campaign Name</th>
                <th className="px-6 py-4 font-medium" data-id="element-2580">Artist</th>
                <th className="px-6 py-4 font-medium" data-id="element-2581">Region</th>
                <th className="px-6 py-4 font-medium" data-id="element-2582">Date Window</th>
                <th className="px-6 py-4 font-medium" data-id="element-2583">Status</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-2584">Targets</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-2585">Replies</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-2586">Offers</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-2587">Confirmed</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border bg-background" data-id="element-2588">
              {campaigns.map((camp, i) => <tr key={i} onClick={() => navigate(`/app/campaigns/${camp.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`)} className="hover:bg-surface/50 transition-colors cursor-pointer group" data-id="element-2589">
                  <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-2590">
                    <div className={`w-2 h-2 rounded-full ${camp.health === 'great' ? 'bg-green-500' : camp.health === 'good' ? 'bg-primary' : camp.health === 'warning' ? 'bg-red-500' : 'bg-border'}`} data-id="element-2591"></div>
                    <span className="group-hover:text-primary transition-colors" data-id="element-2592">
                      {camp.name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-2593">{camp.artist}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-2594">{camp.region}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-2595">{camp.dates}</td>
                  <td className="px-6 py-4" data-id="element-2596">
                    <span className={`px-2 py-1 text-xs rounded font-medium ${camp.status === 'Active' ? 'bg-green-500/10 text-green-500' : camp.status === 'Completed' ? 'bg-blue-500/10 text-blue-500' : camp.status === 'Planning' ? 'bg-primary/10 text-primary' : 'bg-surface border border-border text-textMuted'}`} data-id="element-2597">
                      {camp.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-2598">{camp.targets}</td>
                  <td className="px-6 py-4 text-right" data-id="element-2599">{camp.replies}</td>
                  <td className="px-6 py-4 text-right text-primary font-medium" data-id="element-2600">
                    {camp.offers}
                  </td>
                  <td className="px-6 py-4 text-right text-green-500 font-medium" data-id="element-2601">
                    {camp.confirmed}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}